<template>
<div class="chapter">
<div class="inner_page">
<div class="sbox">
<h2 class="subchapter" id="s005"><a id="page12"></a><span href="#/OEBPS/toc#s5" title="Link target outside of Sample"><em>Chocolate Chip Buttermilk Pancake Casserole</em></span></h2>
<p class="figure"><a id="page13"></a><img alt="" src="OEBPS/images/13-1.jpg"/></p>
<p class="recipe">Yield: Serves 4 | Prep Time: 20 minutes plus 2 hours’ refrigeration | Cook Time: 40 minutes</p>
<p class="recipenote">On Saturdays I make pancakes. Not because they are complicated or because I never seem to have time during the week, but because they are decadent and worthy of a weekend occasion. I am not sure when this tradition started, but it began with standard pancake making and one day a week I would work on pouring perfect pancakes, which never seemed to look too circular. My solution? Turn them into a casserole! Not only is it easier, but it happens to be delicious, while delivering that spot-hitting Saturday pancake essence.</p>
</div>
<p class="serves"><strong>INGREDIENTS</strong></p>
<p class="indger1">4 large eggs</p>
<p class="indger">1 cup heavy cream</p>
<p class="indger">¼ cup maple syrup</p>
<p class="indger">1 teaspoon vanilla bean paste or vanilla extract</p>
<p class="indger">40 mini buttermilk pancakes, homemade or store-bought, frozen and thawed</p>
<p class="indger">2 bananas, thinly sliced</p>
<p class="indger">½ cup mini semisweet chocolate chips</p>
<p class="indger">¼ cup bittersweet chocolate chips</p>
<p class="indger">Powdered sugar</p>
<h2 class="Directions"><strong>DIRECTIONS</strong></h2>
<p class="numhang">1. Lightly coat an 8-inch round cake pan with cooking spray. Whisk together the eggs, cream, maple syrup, and vanilla.</p>
<p class="numhang">2. Layer half of the pancakes in the pan and scatter 1 sliced banana and half of the chocolate chips on top. Pour half of the egg mixture over the pancakes. Repeat with the remaining pancakes, banana, chocolate chips, and egg mixture. Cover the dish with plastic wrap and refrigerate for 2 hours.</p>
<p class="numhang">3. Half an hour before you’re ready to bake the casserole, preheat the oven to 350°F. Remove the plastic wrap and cover the dish with foil. Bake the casserole, covered, for 30 minutes, then remove the foil and bake for an additional 10 minutes. Dust with powdered sugar and serve.</p>
<h2 class="head"><strong>VARIATIONS</strong></h2>
<p class="nonindent">If you prefer a basic buttermilk pancake casserole, remove the chocolate chips. I love how mini pancakes look; I think they are adorable! But of course you can use full-size pancakes and cut them in quarters before placing them in the baking dish.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s005.vue?7de72b17